import React from "react";
import * as Option from "fp-ts/lib/Option";
import { Playlist } from "playlist";
import { config } from "core/utils";
export var block = function (data) {
    return data.uuid !== "3975934b-22a2-4b4d-a10c-e2727448a6fe"
        ? Option.none
        : Option.some({
            key: "newsPlaylist",
            View: function () { return (React.createElement(Playlist, { myChannelsPlaylist: config.newsPlaylistId, playerConfig: {
                    autoplay: false,
                    automute: false,
                    single_play: true,
                    pip: false,
                    sticky: false,
                    titleFlag: true,
                } })); },
        });
};
